import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'

export default function DropdownActionButtonMui({
  id,
  list = [],
  usePortal = true,
  disabled = false
}) {
  const buttonRef = useRef(null)
  const menuRef = useRef(null)
  const [open, setOpen] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const visibleItems = list.filter((item) => !item.disabled)

  const close = () => setOpen(false)
  const updatePosition = () => {
    if (!buttonRef.current) return

    const rect = buttonRef.current.getBoundingClientRect()

    setPosition({
      top: rect.bottom + 6,
      left: rect.left + rect.width / 2
    })
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !buttonRef.current.contains(e.target)
      ) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if (!usePortal || !open) return undefined

    updatePosition()

    const handleViewportChange = () => {
      updatePosition()
    }

    window.addEventListener('scroll', handleViewportChange, true)
    window.addEventListener('resize', handleViewportChange)

    return () => {
      window.removeEventListener('scroll', handleViewportChange, true)
      window.removeEventListener('resize', handleViewportChange)
    }
  }, [open, usePortal])

  const toggle = () => {
    if (disabled) return

    if (usePortal) {
      updatePosition()
    }

    setOpen(v => !v)
  }

  const menuContent = (
    <div
      ref={menuRef}
      className={`poc-dropdown-menu ${usePortal ? 'poc-dropdown-portal' : 'poc-dropdown-inline'}`}
      style={usePortal
        ? {
          top: position.top,
          left: position.left
        }
        : undefined}
    >
      {visibleItems.map((item, index) => (
        <div
          key={item.text || index}
          className="poc-dropdown-item"
          onClick={(e) => {
            e.stopPropagation()
            item.handler?.()
            close()
          }}
        >
          {item.text}
        </div>
      ))}
    </div>
  )

  return (
    <div className="poc-dropdown-container">
      <button
        id={id}
        ref={buttonRef}
        type="button"
        className={`poc-dropdown-btn ${disabled ? 'poc-dropdown-btn--disabled' : ''}`}
        disabled={disabled || visibleItems.length === 0}
        onClick={(e) => {
          e.stopPropagation()
          toggle()
        }}
      >
        <FontAwesomeIcon icon={faEllipsisH} className="poc-dropdown-icon" />
      </button>

      {open && (usePortal ? createPortal(menuContent, document.body) : menuContent)}
    </div>
  )
}
